import { Component, OnDestroy, OnInit, ChangeDetectorRef, NgZone, ElementRef, HostListener, PLATFORM_ID, Inject } from '@angular/core';
import { navigation } from '../../../../../data/header-navigation';
import { DirectionService } from '@services/direction.service';
import { fromEvent, merge, Subject } from 'rxjs';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SharedService } from '@app/_services/shared.service';
import * as _ from 'lodash';
import { HomepageService } from '@app/_services/homepage.service';
import { TranslateHelper } from '@app/_helpers';
import { takeUntil } from 'rxjs/operators';
import { isPlatformBrowser, NgIf } from '@angular/common';
import { SiteService } from '@app/_services/site.service';
import { AuthenticationService } from '@app/_services';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-header-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, RouterLink, TranslateModule]
})
export class LinksComponent implements OnInit, OnDestroy {
    destroy$: Subject<void> = new Subject<void>();
    sectors = [];
    currentPage;
    sectorsOpen = false;
    currentUser;
    private get element(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    constructor(
        public translateHelper: TranslateHelper,
        private sharedService: SharedService,
        private homepageService: HomepageService,
        private direction: DirectionService,
        private translate: TranslateService,
        private elementRef: ElementRef,
        @Inject(PLATFORM_ID) private platformId: any,
        private zone: NgZone,
        public siteService : SiteService,
        private authService: AuthenticationService,
        // private cd: ChangeDetectorRef
    ) {
    }

    ngOnInit(): void {
        this.authService.currentUser.pipe().subscribe((user: any): any => {
            this.currentUser = user;
        });

        this.sharedService.page$.subscribe(page => {
            this.currentPage = page;
        });
        if (isPlatformBrowser(this.platformId)) {

            this.zone.runOutsideAngular(() => {
                fromEvent<MouseEvent>(document, 'mousedown').pipe(
                    takeUntil(this.destroy$)
                ).subscribe((event) => {
                    if (!this.element.contains(event.target as HTMLElement)) {
                        this.zone.run(() => this.closeSectors());
                    }
                });
            });
        }
    }

    ngAfterViewInit(): void {
        this.sectors = [];
        this.homepageService.categories$.subscribe(data => {
            if (!data) {
                return;
            }
            this.sectors = data;
            // if (this.currentPage && this.currentPage != 'homepage') {
            //     let index = this.sectors.findIndex(item => item.seo?.slug == this.currentPage);
            // }
            // this.cd.detectChanges();
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onOutsideTouchClick(): void {
        if (this.sectorsOpen == true) {
            this.zone.run(() => this.closeSectors());
        }
    }

    selectSector(sector) {
        if (!sector?.seo?.slug) {
            return false;
        }
        this.sharedService.pageSubject$.next(sector?.seo?.slug);
    }

    selectionChange(event) {
        this.sharedService.currentCategorySubject$.next(null);
        this.selectSector(event);
        this.closeSectors();
    }

    openSectors(): void {
        this.sectorsOpen = true;
    }

    closeSectors(): void {
        this.sectorsOpen = false;
    }

    toggleSectors(): void {
        this.sectorsOpen = !this.sectorsOpen;
    }

    get hasLinks() {
        return this.siteService.features?.blogs || this.siteService.features?.multiStore || !this.siteService.siteSetting?.companyId;
    }
}
